import "./pages.css";

export const Private1 = () => {
    return(
        <h1 className="content">
            PRIVATE PAGE 1
        </h1>
    );
}